import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { GeoRiskPage } from '@/areas/risk-management/GeoRisk/GeoRiskPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/risk-management/geo-risk')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <GeoRiskPage />;
}
